<template>
	<toggle
		:on-text="toggledOnText"
		:off-text="toggledOffText"
		:toggled="item.is_liked"
		class="btn btn-toggle btn-favorite"
		on-icon="heart"
		off-icon="heart-o"
		type="text"
		@activated="activate()"
		@deactivated="deactivate()"
	></toggle>
</template>

<script>
    import ActionToggle from '../mixins/action-toggle';

    export default{
    	mixins: [ActionToggle],

		props: {
    		entityType: {
    			type: String,
				default: 'lesson'
			}
		},

    	data() {
    		return {
    			addEndpoint: '/api/favorite/' + this.entityType + '/',
    			removeEndpoint: '/api/unfavorite/' + this.entityType + '/'
    		}
    	}
    }
</script>
